define('viewmodels/RiskRating/RiskRatingAnalysis',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {
        var app = require('durandal/app'),
            ko = require('knockout');

        var RiskRatingAnalysisVM = {

        };

        return RiskRatingAnalysisVM;



    });
